<app-nav titulo="Oficinas" descripcion="Aquí podrá ver, editar y borrar todas las oficinas existentes.">
    <div class="offices">
        <app-table-filter [filters]="filters" (values)="setFilterValues($event)"></app-table-filter>
        <app-data-table
            [rows]="offices"
            [columns]="columns"
            [paginatorStatus]="paginatorStatus"
            [externalPagination]="true"
            (updateRows)="updateOffices($event)"
            (sortFn)="updateSort($event)"
        ></app-data-table>
        <button mat-raised-button class="garantor-button add-button" color="primary" routerLink="./nueva">
            <mat-icon matPrefix class="add-button-icon">add</mat-icon>
            <span class="add-button-label">Nueva oficina</span>
        </button>
    </div>
</app-nav>
<ng-template #buttonsColumnTemplate let-row="row">
    <div class="table-row-buttons">
        <button mat-icon-button matTooltip="Cambiar email" class="change-email-row-button" (click)="changeEmail(row)">
            <mat-icon color="primary">alternate_email</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Restablecer contraseña" class="unlock-row-button" (click)="resetUserPassword(row)">
            <mat-icon color="primary">lock_open</mat-icon>
        </button>
        <button mat-icon-button  matTooltip="Ver detalles" class="view-more-row-button" [routerLink]="'./' + row.id">
            <mat-icon color="primary">dehaze</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Editar oficina" class="edit-row-button" [routerLink]="'./' + row.id + '/editar'">
            <mat-icon color="primary">edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Borrar oficina" class="delete-row-button" (click)="deleteOffice(row)">
            <mat-icon color="accent">delete</mat-icon>
        </button>
    </div>
</ng-template>
